import RootLayout from "@/app/layout";
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Typography, Container, Paper, Box, List, ListItem, ListItemText } from '@mui/material';
import data from '../../data/datenschutz/data.json';
import Head from "next/head";

export const metadata = {
  title: 'Hebamme Lea Stiffler | Datenschutz',
  canonicalUrl: 'https://hebamme-leastiffler.ch/datenschutz'
}

export async function getStaticProps() {
  return { props: { data } }
}

export default function Datenschutz({ data }) {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { KontaktText, Kontakt, Datenschutz, Einführung } = data;

  return (
    <RootLayout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.canonicalUrl} />
      </Head>
      <motion.section
        className="section-large"
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: inView ? 1 : 0 }}
        transition={{ duration: 1 }}
      >
        <div className="section-header">
          <div className="section-title">
            <Typography variant="h3" component="h1" gutterBottom align="center">
              {data.Titel}
            </Typography>
            <Typography variant="h3" component="h1" gutterBottom align="center">
              ({data.Datum})
            </Typography>
          </div>
        </div>
        <div className="section-body">
          <Container maxWidth="lg">
            <Box sx={{ mt: 2 }}>
              <Typography paragraph>{KontaktText}</Typography>
              <Typography>{Kontakt.Name}</Typography>
              <Typography>{Kontakt.Strasse}</Typography>
              <Typography>{Kontakt.Postleitzahl} {Kontakt.Ort}, {Kontakt.Land}</Typography>
              <Typography>Email: <a href={`mailto:${Kontakt.EMail}`} style={{ textDecoration: 'none' }}>{Kontakt.EMail}</a></Typography>
              <Typography>Mobile: <a href={`tel:${Kontakt.Mobile}`} style={{ textDecoration: 'none' }}>{Kontakt.Mobile}</a></Typography>
            </Box>
            <Box sx={{ mt: 4 }}>
              <Typography variant="h6" component="h2">Einführung</Typography>
              <Typography paragraph>{Einführung}</Typography>
            </Box>
            <Box sx={{ mt: 4 }}>
              <Typography variant="h6" component="h2">Datenschutzbestimmungen</Typography>
              <List>
                {Datenschutz.map((item, index) => (
                  <ListItem key={index} sx={{ display: 'block', mb: 2 }}>
                    <ListItemText primary={<Typography variant="h6" component="h3">{item.Titel}</Typography>} secondary={item.Text} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Container>
        </div>
      </motion.section>
    </RootLayout>
  );
}
